import script from "./ErrorServidorContent.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorServidorContent.vue?vue&type=script&setup=true&lang=js"

import "./ErrorServidorContent.vue?vue&type=style&index=0&id=3ed197f2&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ed197f2"]])

export default __exports__